import React from 'react';
import { getLastUpdateDateAndTimeFormat } from '../../../helpers/date.js';

export default function CenterPanel(props) {
  return (
    <span>
      <div className="ui form" id="reset-meeting-room-link">
        <label className="div-like mrbs">{APP.LANGUAGE.ResetGuestLink.CurrentGuestLink}</label>
        <div>
          <a className="mrbxl wrap-link hand" target="blank" href={props.selectedMeetingRoom.roomUrl}>
            {props.selectedMeetingRoom.roomUrl}
          </a>
        </div>
        <div>
          <label className="div-like mrbs mrrxs">{APP.LANGUAGE.ResetGuestLink.LastReset}</label>
          <div className="title-sms mrbxl">
            {getLastUpdateDateAndTimeFormat(
              props.selectedMeetingRoom.resetGuestCodeDateUTC,
              props.timezoneOffsetNow,
              'dateOnly'
            ) +
              ' at ' +
              getLastUpdateDateAndTimeFormat(
                props.selectedMeetingRoom.resetGuestCodeDateUTC,
                props.timezoneOffsetNow,
                'timeOnly'
              )}
          </div>
        </div>
      </div>
    </span>
  );
}
